import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl, AbstractControl, Validator, ValidatorFn
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  UserContext
} from '../../../../services/user-context/user-context';
import {ApiService} from '../../../../services/api';

@Component({
  selector: 'app-account-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'account-dialog.template.html',
  styles: [
    "app-account-dialog mat-dialog-container {padding:0;}",
    "app-account-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-account-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}"
  ]
})

export class AccountDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    lastName: '',
    firstName: '',
    email: '',
    type: '',
    currency: '',
    name: '',
    phone: ''
  };
  account:any;
  suppliers: any[];
  distributors: any[];
  waivers: any[];
  types = ['independent', 'retail'];
  disciplines = ['chiropractic', 'physiotherapy', 'private practice', 'multi-discipline', 'wellness', 'pain management', 'foot care', 'esthetician', 'fitness', 'telesales'];
  countries = ['US', 'CA'];

  public typeArray: Array<{ text: string, value: string }> = [
    { text: 'Independent', value: 'independent' },
    { text: 'Retail', value: 'retail' }
  ];

  public fulfillmentArray: Array<{ text: string, value: string }> = [
    { text: 'Orthogenic Lab', value: 'olab' },
    { text: 'Zoom', value: 'zoom' }
  ];

  public currencyArray: Array<string> = [
    'USD',
    'CAD'
  ];

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<AccountDialogComponent>,
              private userContext: UserContext,
              private api: ApiService,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.api.get<any>(`/supplier`)
      .subscribe(result => {
        this.suppliers = result;
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });

    this.api.get<any>(`/distributor`)
      .subscribe(result => {
        this.distributors = result;
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });

    if( data ) {
      this.account = data;
    } else {
      this.account = {
        billing: {},
        contact: {
          billing: { },
          technical: { }
        },
        branding: {
          portal: {},
          app: {}
        },
        security: {},
        gps: {},
        enabled: true,
        locations: [],
      };
    }
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      name: new FormControl(this.account.name, [
        Validators.required,
        Validators.minLength(2)
      ]),
      lastName: new FormControl((this.account.contact || {}).lastName, [
        Validators.required,
        Validators.minLength(2)
      ]),
      firstName: new FormControl((this.account.contact || {}).firstName, [
        Validators.required,
        Validators.minLength(2)
      ]),
      email: new FormControl((this.account.contact || {}).email, [
        Validators.required,
        Validators.email,
        Validators.minLength(3)
      ]),
      billingEmail: new FormControl(((this.account.contact || {}).billing || {}).email, [
        Validators.email,
        Validators.minLength(3)
      ]),
      technicalEmail: new FormControl(((this.account.contact || {}).technical || {}).email, [
        Validators.email,
        Validators.minLength(3)
      ]),
      type: new FormControl(this.account.type || 'retail', [
        Validators.required
      ]),
      discipline: new FormControl(this.account.discipline, [
        Validators.required
      ]),
      country: new FormControl(this.account.country, [
        Validators.required
      ]),
      phone: new FormControl((this.account.contact || {}).phone, [
        Validators.required,
        Validators.minLength(10)
      ]),
      external_id: new FormControl(this.account.external_id, [
      ]),
      distributor_id: new FormControl(this.account.distributor_id, [
      ]),
      supplier_id: new FormControl(this.account.supplier_id, [
      ])

    });

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
  }

  public onValueChanged(data?: any): void {
    if (!this.form) { return; }
    const form = this.form;

    for ( const field of Object.keys( this.formErrors) ) {
      this.formErrors[field] = '';
      const control = form.get(field);

      if (control && control.dirty && !control.valid) {
        for ( const key of Object.keys( control.errors ) ) {
          //this.formErrors[field] = messages[key];
        }
      }
    }
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isManager() {
    return this.userContext.hasRole('manager');
  }

  public save() {
    this.account = Object.assign(this.account, {
      name: this.form.value.name,
      type: this.form.value.type,
      discipline: this.form.value.discipline,
      supplier_id: this.form.value.supplier_id,
      distributor_id: this.form.value.distributor_id,
      external_id: this.form.value.external_id,
      logo: this.form.value.logo,
      domain: this.form.value.domain,
      country: this.form.value.country,
    });
    this.account.billing = Object.assign( this.account.billing || {}, {
        installments: false,
        override: true,
        currency: this.form.value.country === 'CAN' ? 'CAD' : 'USD',
        price: 450,
        license: 0,
        cost: 199,
        minimum: 199,
        installment_reserve: 99,
        model: "invoice"
      });
    this.account.contact = Object.assign( this.account.contact || {}, {
        country: this.form.value.country,
        firstName: this.form.value.firstName,
        lastName: this.form.value.lastName,
        email: this.form.value.email,
        phone: this.form.value.phone,
        billing: { },
        technical: { }
      });
    this.account.contact.billing = Object.assign( this.account.contact.billing || {}, {});
    this.account.contact.technical = Object.assign( this.account.contact.technical || {}, {});
    if( this.form.value.billingEmail ) {
      this.account.contact.billing.email = this.form.value.billingEmail;
    }
    if( this.form.value.techinicalEmail ) {
      this.account.contact.technical.email = this.form.value.techinicalEmail;
    }
    this.dialogRef.close(this.account);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
